<div *ngIf="orderSummary$ | async as summary">
  <div class="order-card-layout" *ngIf="summary.orderItems.length > 0">
    <div class="card-inner">
      <div class="message-wrapper">
        <span class="warning-message">
          <span *ngIf="summary.orderItems.length > 1; else oneProduct">
            {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_EXCESS.ACTIVATING_THIS_PRODUCT' | translate }}
          </span>
          <ng-template #oneProduct>
            {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_EXCESS.ACTIVATING_THESE_PRODUCTS' | translate }}
          </ng-template>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_EXCESS.WILL_PLACE_YOU_OVER_LIMIT' | translate }}
        </span>
      </div>
      <header class="row">
        <div class="col-minor" style="width: 25%">
          {{ 'COMMON.PRODUCT' | translate }}
        </div>
        <div class="col-minor" style="width: 30%">
          {{ 'COMMON.PRICING.WHOLESALE_COST' | translate }}
        </div>
        <div class="col-minor">
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_EXCESS.NUM_PRODUCTS' | translate }}
        </div>
        <div class="col-minor" style="width: 20%">
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_EXCESS.TOTAL_COST' | translate }}
        </div>
      </header>
      <div class="row" *ngFor="let purchase of summary.orderItems">
        <div class="col">{{ purchase.productName }}</div>
        <div class="col" style="display: flex; flex-direction: column; width: 100%">
          <div class="row" *ngFor="let tier of purchase.tierPricing">
            <div class="col" style="width: 100px">{{ tier.tierRange }}</div>
            <div class="col">{{ tier.tierPrice }}</div>
          </div>
        </div>
        <div class="col">{{ purchase.activations }}</div>
        <div class="col">
          <div>
            <span *ngIf="purchase.orderItem.purchaseCost.isStartingPrice">
              {{ 'COMMON.PRICING.STARTING_AT' | translate }}
            </span>
            <ng-container>
              <strong>
                {{ purchase.totalCost | price: purchase.orderItem.purchaseCost.currency }}
                <span>{{ purchase.frequency | titlecase }}</span>
              </strong>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-major"></div>
        <div class="col-major"></div>
        <div class="col-major" style="text-align: center"></div>
        <div class="col-major">
          <div *ngFor="let freqPrice of summary.orderCostFrequency | keyvalue">
            <div class="frequency-price" *ngIf="freqPrice.value > 0">
              <div>
                <strong>
                  {{ freqPrice.value | price: $any(orderCurrency) }}
                  <span *ngIf="freqPrice.key !== 'one_time'">
                    {{ freqPrice.key | titlecase }}
                  </span>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
